import { render, staticRenderFns } from "./CircleButton.vue?vue&type=template&id=73561480&scoped=true&"
import script from "./CircleButton.vue?vue&type=script&lang=js&"
export * from "./CircleButton.vue?vue&type=script&lang=js&"
import style0 from "./CircleButton.vue?vue&type=style&index=0&id=73561480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73561480",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
